import { useCallback, useEffect } from 'react';
import * as actions from '../../actions';
import codes from '../../utils/constants/codes';
import ids from '../../utils/constants/ids';
import ClaimBankDetails from '../../components/claimBankDetails/claimBankDetails';
import claimApplicationProjections from '../../projections/claimApplication';
import questionProjections from '../../projections/question';
import questionFunctions from '../../utils/functions/question';
// @ts-ignore
import _ from 'lodash';
import { useAppSelector, useAppDispatch } from '../../hooks/hooks';
import GENERAL_FUNCTIONS from '../../utils/functions/functions';
import React from 'react';

type Props = { claimApplication: { id: string } };

const ClaimBankDetailsContainer = (props: Props): JSX.Element => {
    const { claimApplication } = props;
    const dispatch = useAppDispatch();
    const loading = useAppSelector(
        claimApplicationProjections.loadingBankDetailsData,
    );
    const updatingClaimBankAccount: boolean = useAppSelector(
        state => state.claimApplication.submitting,
    );
    const bankDetailsAnswers = useAppSelector(
        state => state.claimApplication.bankDetails,
    );
    const initialValues = useAppSelector(
        questionProjections.fitlerAnswersByQuestions(bankDetailsAnswers),
    );
    const questions = useAppSelector(
        questionProjections.questionsWithGroupId(
            ids.claimApplicationBankGroupId,
        ),
    );

    const fetchQuestionsByGroupAction = useCallback(
        (payload: any) =>
            dispatch(actions.fetchQuestionsByGroup(payload as any)),
        [dispatch],
    );

    const fetchQuestionValidationRuleAction = useCallback(
        (payload: undefined) =>
            dispatch(actions.fetchQuestionValidationRule(payload as any)),
        [dispatch],
    );

    const fetchQuestionTypeAction = useCallback(
        (payload: any) => dispatch(actions.fetchQuestionTypes(payload)),
        [dispatch],
    );

    const fetchClaimApplicationBankAccountAnswersAction = useCallback(
        (payload: any) =>
            dispatch(actions.fetchClaimApplicationBankAccountAnswers(payload)),
        [dispatch],
    );

    const updateClaimApplicationBankAccountAction = useCallback(
        (payload: any) =>
            dispatch(actions.updateClaimApplicationBankAccount(payload)),
        [dispatch],
    );

    useEffect(() => {
        fetchQuestionsByGroupAction({
            claimApplicationId: claimApplication.id,
            groupCode: codes.claimApplicationBankDetailsGroupCode,
        });
        fetchClaimApplicationBankAccountAnswersAction({
            claimApplicationId: claimApplication.id,
        });
    }, [
        fetchQuestionsByGroupAction,
        fetchClaimApplicationBankAccountAnswersAction,
    ]);

    useEffect(() => {
        fetchQuestionTypeAction(undefined);
    }, [fetchQuestionTypeAction]);

    useEffect(() => {
        fetchQuestionValidationRuleAction(undefined);
    }, [fetchQuestionValidationRuleAction]);

    const handleBankUpdate: any = (formAnswers: any) => {
        let filteredQuestions = GENERAL_FUNCTIONS.filterObjectBy(
            questions.questionsById,
            (q: { groupId: string }) =>
                q.groupId === ids.claimApplicationBankGroupId,
        );
        const answers = questionFunctions.constructAnswersDTO(
            filteredQuestions,
            questions.questionTypes,
            _.pickBy(
                formAnswers,
                (val: any, key: any) => !!filteredQuestions[key],
            ),
            null,
            [],
        );
        updateClaimApplicationBankAccountAction({
            answers,
            ClaimApplicationId: claimApplication.id,
        });
    };

    return (
        <ClaimBankDetails
            loading={loading}
            questions={questions}
            initialValues={initialValues}
            bankDetailsAnswers={bankDetailsAnswers}
            handleBankUpdate={handleBankUpdate}
            updatingClaimBankAccount={updatingClaimBankAccount}
        />
    );
};

export default ClaimBankDetailsContainer;
